import { render } from "./Drops.vue?vue&type=template&id=51b674f9"
import script from "./Drops.vue?vue&type=script&lang=js"
export * from "./Drops.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__